import type {Store} from 'redux';
import {getLanguage} from 'components/store/application.reducers';

/**
 * Keeps `<html lang>` on the language the UI actually renders in: `index.html` ships a fixed
 * `lang="en"`, and a document claiming a language it is not is what makes browsers offer to
 * translate - which rewrites text nodes React tracks and crashes its next commit.
 *
 * A store subscription rather than a component: this writes one attribute and renders nothing, so
 * going through the render tree only bought it re-renders on every startup language dispatch and
 * on any parent render. Returns the unsubscribe.
 */
export function syncDocumentLanguage(store: Store): () => void {
    let applied: string | undefined;

    const apply = (): void => {
        const language = getLanguage(store.getState());

        if (language && language !== applied) {
            applied = language;
            document.documentElement.lang = language;
        }
    };

    apply();

    return store.subscribe(apply);
}
